<template>
  <div class="CountDownTip" v-if="displayText">
    <svg fill="none" version="1.1"
         width="19.364748001098633" height="21.725893020629883" viewBox="0 0 19.364748001098633 21.725893020629883">
      <g>
        <path
            d="M8.45744,2.01275L8.45744,1.18561C8.45744,0.533836,9.00747,0,9.68258,0C10.3561,0,10.9077,0.533836,10.9077,1.18561L10.9077,2.01275C14.4757,2.59469,16.5475,5.72167,16.5475,9.48491L16.5475,14.0473L19.0491,16.1206C19.4596,16.7833,19.4708,17.2923,19.0763,17.9627C18.6835,18.6362,17.9715,18.72,17.1745,18.72L2.19066,18.72C1.39368,18.72,0.681694,18.6362,0.287213,17.9658C-0.105663,17.2954,-0.0944383,16.7833,0.314474,16.1237L0.357771,16.0616L2.80002,14.0489L2.80002,9.48646C2.80002,5.72322,4.88627,2.59469,8.45744,2.01275ZM11.7223,19.3686C11.7223,20.4596,10.8083,21.7259,9.68097,21.7259C8.55366,21.7259,7.63962,20.4596,7.63962,19.3686L11.7223,19.3686Z"
            fill="#FF5555" fill-opacity="1"/>
      </g>
    </svg>
    <div class="tip" v-html="displayText"></div>
  </div>
</template>

<script>


export default {
  name: "CountDownTip",
  data: function () {
    return {
      displayText: "",

      cjTime: "2024-04-14",
      zgTime: "2024-04-13",

      cjCourseIds: [
          "866947576004005888","821997719963439104","821644623026458624","879627315571257344"
      ],
      zgCourseIds: [
          "866954814970052608","866947605670326272","2866947601455038464","866947597680168960",
          "866947590394662912","866947582081552384","823445717432004608","821997764859269120",
          "821997730998644736","821997723918659584","821997695183491072","821997691295371264","821997682801893376",
          "821997632738680832","823442061303341056","822979376426127360","822048268125605888","822045621716914176",
          "821997711918755840","821997703353982976","821997679047995392","821997675025653760",
      ],
    };
  },
  methods: {},
  created() {
    const now = new Date();
    let zgi = this.zgCourseIds.indexOf(window.PAGE_PARAMS.courseId)
    if (zgi != -1) {
      const zgDate = new Date(this.zgTime);
      const timeDiff = Math.abs(zgDate.getTime() - now.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (diffDays > 0) {
        this.displayText = `距离24年主管护师考试仅剩<span>${diffDays}</span>天`
      }
      return
    }
    let cji = this.cjCourseIds.indexOf(window.PAGE_PARAMS.courseId)
    if (cji != -1) {
      const cjDate = new Date(this.cjTime);
      const timeDiff = Math.abs(cjDate.getTime() - now.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
      if (diffDays > 0) {
        this.displayText = `距离24年初级护师考试仅剩<span>${diffDays}</span>天`
      }
      return
    }
  },
  mounted() {

  },

  components: {}
};
</script>
<style lang="scss" scoped>
.CountDownTip {
  display: flex;
  width: 100%;
  align-items: center;
  height: 40px;
  color: #fff;
  font-size: 14px;
  padding: 0 12px;
  background: rgba(64, 75, 94, 0.86);

  .tip {
    margin-left: 10px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  ::v-deep span {
    font-size: 26px;
    position: relative;
    bottom: 4px;
  }
}
</style>
